module.exports = "<div class=\"form-example\">\r\n  <!--<div>Preview:</div>-->\r\n  <label class=\"item item-input text-input-container\">\r\n    <textarea type=\"text\" rows=\"2\" placeholder=\"{{'forms.text_long.input.placeholder' | translate}}\" class=\"text-input\"\r\n              disabled></textarea>\r\n  </label>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/js/forms/directives/field-templates/text-long/preview.html
// module id = 3407
// module chunks = 0